import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonResponse, PaginatedRequest, PaginatedResponse, buildPaginatedParams, User } from '../models';
import { Observable } from 'rxjs';
import { ManagedProfile, ProfileUser } from '../models/profile/profile';

@Injectable({ providedIn: 'root' })

/**
 * User service
 */
export class UserService {
	/**
	 *
	 * @param {HttpClient} _http
	 */
	constructor(private _http: HttpClient) {}

	/**
	 * Get all users
	 */
	getAll(request: PaginatedRequest<{ deleted?: boolean; columns?: Record<string, any> }> = {}): Observable<PaginatedResponse<User>> {
		return this._http.get<PaginatedResponse<User>>(`/users`, {
			params: buildPaginatedParams(request),
		});
	}

	/**
	 * Get user by id
	 */
	getById(id: string): Observable<CommonResponse<User>> {
		return this._http.get<CommonResponse<User>>(`/users/${id}`);
	}

	insertUser(user: User | FormData): Observable<CommonResponse<User>> {
		return this._http.post<CommonResponse<User>>(`/users`, user);
	}

	updateUser(id: string, user: User | FormData): Observable<CommonResponse<boolean>> {
		if (user instanceof FormData) {
			user.append('_method', 'PUT');
			return this._http.post<CommonResponse<boolean>>(`/users/${id}`, user);
		}

		return this._http.put<CommonResponse<boolean>>(`/users/${id}`, user);
	}

	deleteUser(id: string): Observable<CommonResponse<boolean>> {
		return this._http.delete<CommonResponse<boolean>>(`/users/${id}`);
	}

	restoreUser(id: string): Observable<CommonResponse<boolean>> {
		return this._http.post<CommonResponse<boolean>>(`/users/${id}/restore`, {});
	}

	changeState(id: string, state: boolean): Observable<CommonResponse<User>> {
		const stateNew = state ? 1 : 0;
		return this._http.get<CommonResponse<User>>(`/users/${id}/state/${stateNew}`);
	}

	currentUser(): Observable<CommonResponse<User>> {
		return this._http.get<CommonResponse<User>>(`/auth/user-profile`);
	}

	updateProfilo(user: User | FormData): Observable<CommonResponse<User>> {
		return this._http.post<CommonResponse<User>>(`/users/profile/update`, user);
	}

	getManagedProfiles(): Observable<CommonResponse<Array<ManagedProfile>>> {
		return this._http.get<CommonResponse<Array<ManagedProfile>>>('/profiles/managed_profiles/filtered_by/auth_user');
	}

	toggleActiveUser(id: string): Observable<any> {
		return this._http.put(`/users/${id}/toggle-active`, {});
	}

	getProfileUsers(id: string): Observable<CommonResponse<Array<ProfileUser>>> {
		return this._http.get<CommonResponse<Array<ProfileUser>>>(`/users/${id}/profile_users`);
	}
}
